<template>
  <div class="row">
    <div class="col-sm-12">
      <ClientB2c2bCard :client="client" :commercials="commercials" />
    </div>
  </div>
</template>

<script>
import ClientB2c2bCard from "@/components/client/ClientB2c2bCard.vue";

export default {
  components: {
    ClientB2c2bCard,
  },

  props: {
    client: {
      type: Object,
      required: true,
    },

    commercials: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
